import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import {
  BackgroundColors,
  TextColors,
} from '@picsart/design-system/foundation/colors';
import {
  FontSizes,
  LineHeights,
} from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { canHover } from '@picsart/design-system/styleUtils/hoverTouch';
import { hideScrollbars } from '@picsart/design-system/styleUtils/hideScrollbars';
import { textOverflowHidden } from '@/utils/styles/dsStyleHelpers';

const useStyles = createUseStyles(
  {
    root: {
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
      padding: [Spacings.s8, Spacings.s8, Spacings.s16],
      ...hideScrollbars,
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: Spacings.s8,
      padding: [Spacings.s4, Spacings.s8],
    },
    title: {
      fontSize: FontSizes.t4,
      lineHeight: `${LineHeights.t4}px`,
      fontWeight: FontWeights.semibold,
      color: TextColors.base,
    },
    list: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s4,
      borderRadius: CornerRadius.r8,
      [canHover]: {
        '&:hover': {
          backgroundColor: BackgroundColors.tint2,
        },
      },
    },
    term: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s12,
      flex: 1,
      minWidth: 0,
      padding: [Spacings.s10, Spacings.s8],
      border: 'none',
      backgroundColor: 'transparent',
      color: TextColors.base,
      textAlign: 'start',
      cursor: 'pointer',
    },
    clockIcon: {
      width: Spacings.s16,
      height: Spacings.s16,
      flexShrink: 0,
      color: TextColors.tint2,
    },
    termText: {
      fontSize: FontSizes.t4,
      lineHeight: `${LineHeights.t4}px`,
      ...textOverflowHidden,
    },
    removeButton: {
      flexShrink: 0,
    },
  },
  { name: 'search-recent' }
);

export default useStyles;
